module.exports = __webpack_public_path__ + "img/word.b08ebc49.png";